(function($) {


  // form_submit function:
  function form_submit() {

    // Full URL
    var url = window.location.href;

    // Page path
    var pathname = window.location.pathname;

    //Parent div
    var parent_div = $(this).parent().attr("id");

    // The Kitchen:
    if (url.toLowerCase().indexOf("ravintolakitchen.fi") >= 0) {


      // Kysy meiltä lomake:
      if (parent_div.toLowerCase().indexOf("f154") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Kysy-Meilta-Lomake-Lahetetty-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Uutiskirje:
      if (parent_div.toLowerCase().indexOf("f211") >= 0){
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Uutiskirje-Tilattu-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Pyydä tarjous pikkujouluista
      if (parent_div.toLowerCase().indexOf("f1074") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Tarjous-pikkujouluista-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

    }



    // Wanha Makasiini Bistro:
    if (url.toLowerCase().indexOf("ravintolawanhamakasiini.fi") >= 0) {


      // Kysy meiltä lomake:
      if (parent_div.toLowerCase().indexOf("f71") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Kysy-Meilta-Lomake-Lahetetty-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Uutiskirje:
      if (parent_div.toLowerCase().indexOf("f72") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Uutiskirje-Tilattu-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Pyydä tarjous pikkujouluista
      if (parent_div.toLowerCase().indexOf("f573") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Tarjous-pikkujouluista-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

    } // endof Wanha Makasiini Bistro



    // Ravintola Tang Capital:
    if (url.toLowerCase().indexOf("tangcapital.fi") >= 0) {

      // Kysy meiltä lomake:
      if (parent_div.toLowerCase().indexOf("f93") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Kysy-Meilta-Lomake-Lahetetty-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Uutiskirje:
      if (parent_div.toLowerCase().indexOf("f94") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Uutiskirje-Tilattu-Sivulta-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

      // Pyydä tarjous pikkujouluista
      if (parent_div.toLowerCase().indexOf("f547") >= 0) {
        try{
          dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submit',
            'eventLabel' : 'Tarjous-pikkujouluista-'+pathname,
            'eventValue' : 0,
          });
        }catch(err){
          console.log("Tracking pageview virhe!");
        }
      }

    } // endof if Tang Capital



  } // endof form_submit function



  $( document ).ready(function() {

    /* Initialize Foundation */
    $(document).foundation();

    /* form submit */
    $('.wpcf7-form').submit(form_submit);

    // Open form click
    $('a').click(function () {

       console.log('Hash: ' + this.hash);

       if(this.hash){
          if ( this.hash == '#avaa-lomake' ){
               $(this).parent().hide();
             $('.hide').removeClass('hide');
          }
          if ( this.hash == '#kysy-lisaa' || this.hash == '#ota-yhteytta' || this.hash == '#tarjous-catering' || this.hash == '#tarjous-tilat') {

            $('html, body').animate({
                scrollTop: $("#scrollaa").offset().top - 70,
          }, 1500);

          }
       }
    });


    $('a[href*=\\#]').on('click', function(event) {

      event.preventDefault();
      // var urlHash = $(this).attr('href');

      $('html,body').animate({
        scrollTop: $(this.hash).offset().top -70,
      }, 1000, function () {

      });
    });


    // Tarkasta tukeeko selain svg kuvia. Jos tuke ei ole käytä png kuvia silloin.
    /*
    if(!Modernizr.svg) {
      $('img[src$=".svg"]').attr('src', function () {
        return $(this).attr('src').replace('.svg', '.png');
      });
    }
    */

  }); // #endof document ready

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/custom.js